import { GuaranteesBeneficiarySanctionsStatus } from '~/store/guarantees/types.ts';

export const MANAGER_TERMS_TEXT = {
  sectionTitle: 'Умови PM менеджера',
  sectionDescription: 'Заповніть умови для подальшого опрацювання заявки.',
  sectionStepLabel: '02',
  debtTypeLabel: 'Тип заборгованості',
  beneficiarySanctionsStatusLabel: 'Статус бенефіціара у санкційних списках',
  loadingText: 'Завантаження умов PM менеджера...',
  saveButton: 'Зберегти умови PM',
  submitStep3Button: 'Підтвердити',
  savedMessage: 'Умови PM менеджера збережено',
  submittedToUdbtfMessage:
    'Умови PM менеджера підтверджено. Заявку переведено на крок УДБТФ.',
} as const;

export const BENEFICIARY_SANCTIONS_STATUS_OPTIONS = [
  {
    label: 'Бенефіціар наявний у санкційних списках',
    value: GuaranteesBeneficiarySanctionsStatus.PRESENT,
  },
  {
    label: 'Бенефіціар відсутній',
    value: GuaranteesBeneficiarySanctionsStatus.ABSENT,
  },
] as const;
